import React from "react";
import { Modal } from "react-bootstrap";

const AccessibilityHelperModal = (props:any)=> {


return (
    <>
        <Modal
          show={props.show}
          onHide={props.handleClose}
          backdrop="static"
          keyboard
          centered
          id="accessibility-modal"
          aria-labelledby="accessibility-modal-title"
          backdropClassName="custom-backdrop"
        >
          <Modal.Header closeButton style={{ paddingBottom: 0 }}>
            <Modal.Title as="h2" id="accessibility-modal-title">
              How {props.parent === "av" ? "audio and video" : "document"} accessibility works
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="accessibility-modal-body">
            {/* <div className="modal-title">
              <Modal.Title>OTP Verification</Modal.Title>
            </div> */}
            <h3>Supported input files</h3>
            {props.parent === 'doc' && <p>
            PDF under 300 mb.
            </p>}
            {props.parent === 'av' && <p>
              An audio/video (MP3, MP4, WAV, etc.) under 200MB.
            </p>}
            <h3 className="mt-3">Features</h3>
            <ul>
                {props.parent === 'doc' && <>
                  <li>Support for heavy math documents.</li>
                <li>Handle two-columns, headings, tables, lists, etc. for all documents.</li>
                <li>You can create and use optional tags during the conversion process which help you to organize your files better. Think of them as folders.</li>
                </>}
                {props.parent === 'av' && <>
                  <li>In the case of captions, you can optionally train a custom model if your audio/video contains domain-specific content (e.g., in the case of specialized courses such as Indian History, Biology, etc.) by uploading relevant content (e.g. textbook). This will produce better captions.</li>
                <li>You can create and use optional tags during the conversion process which help you to organize your files better. Think of them as folders.</li>
                </>}
            </ul>
            <h3 className="mt-3">Output formats</h3>
            {props.parent === 'doc' && <p>docx</p>}
            {props.parent === 'av' && <p>Output format for captions: TXT</p>}
            <h3 className="mt-3">How it works</h3>
            <p>Once the file is converted, you will receive an email with a link to download the file, and the file will also be available on the Nclude.AI portal under the "document accessibility" tab.</p>
            
          </Modal.Body>
        </Modal>
        </>
)
}
 export default AccessibilityHelperModal;
